
import $store from '@/store'
import Vue from 'vue'
import $router from '@/router'
// 设置公共的分页size大小
const PAGE_SIZE = 20

// 税务登记证号正则
const validateTax = (rule, value, callback) => {
  const reg = /[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}/
  if (value == '' || value == undefined || value == null) {
    callback()
  } else {
    if (!reg.test(value)) {
      callback(new Error('请输入正确的税务登记账号'))
    } else {
      callback()
    }
  }
}
// 验证统一社会信用代码
const validateSUCC = (rule, value, callback) => {
  const reg = /[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}/
  if (value == '' || value == undefined || value == null) {
    callback()
  } else {
    if (!reg.test(value)) {
      callback(new Error('请输入正确的税务登记账号'))
    } else {
      callback()
    }
  }
}
// 验证邮编
const validatePostCode = (rule, value, callback) => {
  const reg = /^[a-zA-Z0-9 ]{3,12}$/
  if (value == '' || value == undefined || value == null) {
    callback()
  } else {
    if (!reg.test(value)) {
      callback(new Error('请输入正确的邮编'))
    } else {
      callback()
    }
  }
}
// 关于手机号码验证
const validatePhone = (rule, value, callback) => {
  const reg = /^[1][3-9][0-9]{9}$/
  // 验证区号的

  if (value == '' || value == undefined || value == null) {
    callback()
  } else {
    if (!reg.test(value)) {
      callback(new Error('请输入正确的电话号码'))
    } else {
      callback()
    }
  }
}
// 手机+座机验证
const validatePhones = (rule, value, callback) => {
  const reg = /^[1][3-9][0-9]{9}$/
  // 验证区号的
  const reg_landline = /^[0][1-9]{2,3}(-|－)[0-9]{5,10}$/
  if (reg.test(value) || reg_landline.test(value)) {
    callback()
  } else {
    callback('请输入正确的电话号码')
  }
}

// 格式化时间的方法
const getTime = () => {
  // 获取当前时间
  let date = new Date()
  let time = formatDate(date)
  return time
}

// 添加0的方法
const addZero = (value) => {
  if (value < 10) {
    return '0' + value
  } else {
    return value
  }
}

// 三级二级联动数据混合
const linkDataArray = (data, attribute) => {
  if (data[attribute]) {
    if (data[attribute][1] === 'null' ||
            !data[attribute][1]) {
      let arry = []
      arry.push(data[attribute][0])
      return arry
    }
    if (
      data[attribute][2] === 'null' ||
            !data[attribute][2]
    ) {
      let arry = []
      arry.push(data[attribute][0])
      arry.push(data[attribute][1])
      return arry
    }
  }
  return data[attribute]
}
// 取数组最后一个不为空的值
const getLastId = (arr) => {
  if (!arr || arr.length === 0) {
    return ''
  } else {
    let len = arr.length
    let val = ''
    for (let i = len; i > -1; i--) {
      if (arr[i]) {
        val = arr[i]
        break
      }
    }
    return val
  }
}
// 格式化输入时间的方法
const formatDate = (value) => {
  let date = new Date(value)
  let year = date.getFullYear()
  let month = date.getMonth() + 1
  let day = date.getDate()
  let hour = date.getHours()
  let minute = date.getMinutes()
  let second = date.getSeconds()
  month = addZero(month)

  day = addZero(day)
  hour = addZero(hour)
  minute = addZero(minute)
  second = addZero(second)

  let time =
        year +
        '-' +
        month +
        '-' +
        day +
        ' ' +
        hour +
        ':' +
        minute +
        ':' +
        second
  return time
}
const statusNameToNumber = (name) => {
  /// /////////已经接收的简历中
  switch (name) {
    case '全部':
      return null
    case '合适' || '已邀请':
      return '1'
    case '不合适' || '未邀请':
      return '2'
    case '待定' || '已反馈':
      return '3'
    case '面试邀请' || '未反馈':
      return '4'
    case '未判断':
      return '5'
    case '未读':
      return '6'
    case '线上招聘会':
      return '7'
    case '线下招聘会':
      return '8'
    case '网络投递':
      return '9'
  }
  /// ///////////////////////////面试管理中
  if (name === '已邀请') {
    return '1'
  }
  if (name === '未邀请') {
    return '2'
  }
  if (name === '已反馈') {
    return '3'
  }
  if (name === '未反馈') {
    return '4'
  }
}
// 去掉数组中的null
const filterLinkData = (data) => {
  let arry = []
  if (data.length > 0) {
    if (data[data.length - 1] && data[data.length - 2]) {
      return data
    }
    if (!data[data.length - 1] && data[data.length - 2]) {
      arry.push(data[0])
      arry.push(data[1])
    }
    if (!data[data.length - 1] && !data[data.length - 2]) {
      arry.push(data[0])
    }
  }
  return arry
}
const getPath = (path, type) => {
  ['subAccountManage', 'enterpriseManage', 'jobManage', 'error', 'browseResume',
    'jobFair', 'jobSubsidy', 'interviewManage', 'dataReport'].forEach(item => {
    if (path.indexOf(item) > -1) {
      path = '/' + item + '/common'
    }
  })
  switch (type) {
    // 企业信息
    case 'invoice':
      path = path + '/invoiceManagement'
      break
    case 'safe':
      path = path + '/safeSetting'
      break
    case 'jobSubsidy':
      path = path + '/jobSubsidyRecord'
      break
    default:
      path = path + '/' + type
      break
  }
  return path
}

// 验证审核状态的提示
const verifyAuditStatusTip = (tipMessage, tip, type) => {
  Vue.prototype.$confirm(tipMessage, tip, {
    confirmButtonText: '确定'
  })
    .then(() => {
      $router.push('/' + type + '/common/account')
    })
}
// 判断审核状态
const judyStatus = (method, type) => {
  switch ($store.state.base.userInfo['auditStatus']) {
    case 0:
      verifyAuditStatusTip(
        '您的企业还没有进行认证，是否进行认证?',
        '提示', type
      )
      break
    case 1:
      verifyAuditStatusTip(
        '您提交的企业信息正在审核中，请您耐心等待...',
        '提示', type
      )
      break
    case 3:
      verifyAuditStatusTip(
        '您填写的企业信息被驳回，是否重新前往填写认证',
        '提示', type
      )
      break

    default:
      method()
      break
  }
}
// 检查职位类型存在不同
const checkPositionTypeisExistDiff = (positionTypes) => {
  let isDiff = false
  positionTypes.forEach(positionType => {
    positionTypes.forEach(positionType1 => {
      if (positionType != positionType1) {
        isDiff = true
      }
    })
  })
  return isDiff
}
// 确认公共部分抽取
const confirmTip = (text, method) => {
  Vue.prototype.$confirm(text, '温馨提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning',
    center: true
  })
    .then(() => {
      method()
    })
    .catch(() => { })
}

export {
  checkPositionTypeisExistDiff,
  validatePostCode,
  validateTax,
  validatePhones,
  validatePhone,
  confirmTip,
  PAGE_SIZE,
  validateSUCC,
  getPath,
  getTime,
  formatDate,
  linkDataArray,
  getLastId,
  judyStatus,
  filterLinkData,
  statusNameToNumber

}



// WEBPACK FOOTER //
// ./src/assets/js/enterprise/index.js